import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { environment } from 'src/environments/environment';

declare var Razorpay: any;

@Component({
  selector: 'app-make-payment-layout',
  templateUrl: './make-payment-layout.component.html',
  styleUrls: ['./make-payment-layout.component.scss'],
})
export class MakePaymentLayoutComponent implements OnInit {
  cart: any;
  data: any;
  rzp1;

  constructor(
    private transactionService: TansactionService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((data) => {
      this.transactionService
        .getTransactionData(data.id)
        .then((data: any) => {
          if (data.event == 'payment.pending') {
            this.openRazorPay(data);
          } else {
            this.router.navigate([
              'cart/verify/',
              this.cart.razor_order_details.id,
            ]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  openRazorPay(transaction) {
    // let successUrl = "http://localhost:4200/cart/verify/" + this.cart.plan.id;

    let razorPayOptions = {
      key: environment.RAZOR_PAY_KEY.KEY_ID,
      // key_id: environment.RAZOR_PAY_KEY.KEY_ID,
      // key_secret :  environment.RAZOR_PAY_KEY.KEY_SECRET,
      amount: transaction.order.amount_due,
      currency: "INR",
      // name: 'TheKredible.com',
      order_id: transaction.order.id,
      customer_id: transaction.account_id,
      prefill: {
        email: this.localStorageService.getItem('email'),
        contact: this.localStorageService.getItem('mobile'),
        name: this.localStorageService.getItem('name'),
      },
      handler: (response: any) => {
        this.razorPayResponseHandler(response);
      },
      modal: {
        confirm_close: true,
        remember_customer: true,
        ondismiss: () => {
          this.localStorageService.setItem('reloadPage', 'true');
          this.router.navigate(['cart']);
          // console.log("test");
        },
      },
    };

    this.rzp1 = new Razorpay(razorPayOptions);
    this.rzp1.open();

    this.rzp1.on('payment.failed', (response: any) => {
      this.localStorageService.setItem('reloadPage', 'true');
      this.router.navigate(['account/transaction/', this.cart.plan.id]);
    });
  }

  razorPayResponseHandler(response: any) {
    this.localStorageService.setItem('reloadPage', 'true');
    this.router.navigate(['account/transaction/', response.razorpay_order_id]);
    //TODO: this will tell when razorpay popup is closed
  }
}
